/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Sign_In_DescriptionInputs */

const en_common_sign_sign_in_description = /** @type {(inputs: Common_Sign_Sign_In_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome back`)
};

const zh_common_sign_sign_in_description = /** @type {(inputs: Common_Sign_Sign_In_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎回来`)
};

/**
* | output |
* | --- |
* | "Welcome back" |
*
* @param {Common_Sign_Sign_In_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_sign_in_description = /** @type {((inputs?: Common_Sign_Sign_In_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Sign_In_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_sign_in_description(inputs)
	return zh_common_sign_sign_in_description(inputs)
});
export { common_sign_sign_in_description as "common.sign.sign_in_description" }